import React, { Component } from 'react';
import { Text, View, TouchableOpacity, StyleSheet, Image } from 'react-native';
import images from "../images/ImagesControl";

class ProductList extends Component {
    state = {
        product: [
            {
                id: 0,
                code: 'Apple',
            },
            {
                id: 1,
                code: 'Banana',
            },
            {
                id: 2,
                code: 'Peach',
            },
            {
                id: 3,
                code: 'Orange',
            }
        ]
    }

    render() {
        return (
            <View>
                <Text style={styles.titleList}>
                    {
                        "Product List"
                    }
                </Text>
                {
                    this.state.product.map((item, index) => (
                        <TouchableOpacity
                            key={item.id}
                            style={[styles.container, { flexDirection: 'row' }]}
                            onPress={() => { this.props.onPress(item) }}>
                            <Image source={(item.id === 1)
                                ? images.apple
                                : (item.id === 2)
                                    ? images.banana
                                    : (item.id === 3)
                                        ? images.peach
                                        : images.orange
                            }
                                style={{ height: 40, width: 30, resizeMode: 'contain' }} />
                            <Text>{"   "}</Text>
                            <Text style={styles.text}>
                                {item.code}
                            </Text>
                        </TouchableOpacity>
                    ))
                }
            </View>
        )
    }
}

const styles = StyleSheet.create({
    titleList: {
        padding: 10,
        backgroundColor: '#c8e1ff',
        alignItems: 'center',
        borderColor: '#c8e1ff',
        height: 40,
        fontWeight: 'bold',
    },
    container: {
        padding: 10,
        backgroundColor: '#c8e1ff',
        alignItems: 'center',
        borderColor: '#c8e1ff',
        height: 40,
    },
    text: {
        color: '#4f603c',
    }
})

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/ProductList.js